
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/geburtsvorbereitungskurs",
      function () {
        return require("private-next-pages/geburtsvorbereitungskurs/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/geburtsvorbereitungskurs"])
      });
    }
  